module.exports = __webpack_public_path__ + "img/sankalp_global_summit.47e17afd.png";